export default __webpack_public_path__ + "static/114-d978e0582a12388721e07a8f77eae7ac.gif";